export const payersError = 'Aggregator combination not found';

export const payersListHeaders = [
  { header: 'payerID', label: 'PAYER ID' },
  { header: 'payerName', label: 'PAYER NAME' },
];
